import { useState } from 'react';
import { useAdjustMembershipPoints } from '../queries';

type ManualPointsAdjustmentDrawerProps = {
  open: boolean;
  membershipUuid?: string;
  onClose: () => void;
};

const makeId = () => (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
  ? crypto.randomUUID()
  : `${Date.now()}-${Math.random().toString(16).slice(2)}`);

const ManualPointsAdjustmentDrawer = ({ open, membershipUuid, onClose }: ManualPointsAdjustmentDrawerProps) => {
  const adjustMutation = useAdjustMembershipPoints();
  const [deltaPoints, setDeltaPoints] = useState('');
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  if (!open) return null;

  const handleSubmit = async () => {
    if (!membershipUuid) return;
    const delta = Number(deltaPoints);
    if (!Number.isFinite(delta) || delta === 0) {
      setError('Enter a non-zero points adjustment.');
      return;
    }
    if (reason.trim().length < 3) {
      setError('Reason is required.');
      return;
    }
    setError('');
    try {
      const idempotencyKey = `manual-adjust:${makeId()}`;
      await adjustMutation.mutateAsync({
        membershipUuid,
        deltaPoints: Math.round(delta),
        reason: reason.trim(),
        idempotencyKey
      });
      setDeltaPoints('');
      setReason('');
      onClose();
    } catch (_error) {
      setError('Unable to apply adjustment right now.');
    }
  };

  return (
    <div className="membership-drawer-overlay" onClick={onClose}>
      <div className="membership-drawer-panel" onClick={(event) => event.stopPropagation()}>
        <div className="membership-drawer-panel__header">
          <h3>Manual points adjustment</h3>
          <button type="button" className="membership-drawer-panel__close" onClick={onClose} aria-label="Close">×</button>
        </div>
        <div className="membership-drawer-panel__form">
          <label className="field">
            <span className="label">Delta points (signed)</span>
            <input className="input" value={deltaPoints} onChange={(e) => setDeltaPoints(e.target.value)} placeholder="e.g. 500 or -300" />
          </label>
          <label className="field">
            <span className="label">Reason</span>
            <textarea className="input" rows={3} value={reason} onChange={(e) => setReason(e.target.value)} />
          </label>
          {error ? <p className="appointments-v2-empty-copy">{error}</p> : null}
          <div className="membership-drawer-panel__actions">
            <button type="button" className="btn ghost" onClick={onClose}>Cancel</button>
            <button type="button" className="btn primary" onClick={handleSubmit} disabled={adjustMutation.isPending}>
              {adjustMutation.isPending ? 'Applying...' : 'Apply adjustment'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManualPointsAdjustmentDrawer;
